import React from 'react';
import {
	Page,
	List,
	NavLeft,
	NavRight,
	Link,
	ListItem,
	ListGroup,
	BlockTitle, Toggle, Popup, Navbar,
} from 'framework7-react';
import {IWBarcodeReader, IWBins, IWHeader, IWLocalAutocomplete, SelectAutomezzi} from "../IWComponents";
import Deposito from "../entities/Deposito"
import Trasporti from "../entities/Trasporti";
import Mezzi from "../entities/Mezzi";
import IWAjax from "../utils/IWAjax";
import Dom7 from "dom7";
import Soci from "../entities/Soci";

export default class MovimentazioneBins extends React.Component {
	opt;

	constructor(props) {
		super(props);

		const opt = this.props.opt;
		let sorgente = new Deposito();
		let destinazione = {};

		if (opt === "s2o" || opt === "c2o" || opt === "m2o") {
			destinazione = sorgente;
			sorgente = {};
		}

		if (opt === "c2s") {
			sorgente = {}
			destinazione = {}
		}

		if (opt === "o2o"){
			destinazione = sorgente;
		}

		this.state = {
			magazzino_destinazione: destinazione,
			magazzino_sorgente: sorgente,
			movimentazioni: [],
			tot_bins: 0,
			bins: [],
			idsocio: undefined,
			bins_giacenza: 0,
			max_bins: 0,
			bolletta_bins: 0,
			is_vuoti_camion: false,
			is_vuoti_socio: false,
			barcode_pesate: [],
			idmezzo: 0,
			tipo_bin: 0,
			numero_bins: 0,
			giacenza_tipo_bins: [],
			qtot: 0,
			note_movimentazione: "",
			bollette_da_viaggio: []
		};

		this.socioChanged = this.socioChanged.bind(this)
		this.automezzoChanged = this.automezzoChanged.bind(this);
	}

	async componentDidMount() {
		const self = this;
		global.app = self.$f7;
		localStorage.setItem("is_bolletta_bin", "0");
		document.addEventListener('paste', self.handlePaste);

		if (self.props.opt === "s2m") {
			const camion = localStorage.getItem("camion")
			if (camion !== "") {
				const mezzi = await new Mezzi();
				mezzi.getById(camion).then(r => {
					self.setState({magazzino_destinazione: r, magazzino_sorgente: {}});
				});
			}
		}

		if (self.props.opt === "c2s") {
			const camion = localStorage.getItem("camion")
			if (camion !== "") {
				const mezzi = await new Mezzi();
				mezzi.getById(camion).then(r => {
					self.setState({magazzino_sorgente: r});
				});
			}
		}
		if (self.props.opt === "m2o") {
			self.$f7.smartSelect.get('.smart-select').setValue(0);
		}
	}

	componentWillUnmount() {
		localStorage.setItem("is_bolletta_bin", "0");
	}

	socioChanged(event) {
		const self = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;

		self.setState({
			[name]: value
		}, function () {
			if (self.props.opt.endsWith("2s")) {
				return IWAjax({
					app: self.$f7,
					route: 'getGiacenzaMagazzinoSocio',
					data: {
						idmagazzino: self.state.magazzino_destinazione._id,
						idanagrafica: self.state.magazzino_destinazione.idanagrafica
					},
					showPreloader: false,
					success: function (res) {

						let giacenza = res.data.rows;
						let bins_giacenza = [];
						let nbins = 0;
						let max_bins = res.data.max_bins;
						if (giacenza !== null) {
							giacenza.forEach((elem) => {
								bins_giacenza.push(elem);
								nbins += parseInt(elem.q);
							});
						}
						self.setState({
							giacenza_bins: bins_giacenza,
							qtot: nbins,
							max_bins: max_bins
						}, () => self.updateBinsList());
					},
					error: function (error) {
						console.log(error);
					}
				});
			}
		});
		//self.giacenzaBollettaNonLavorata();
	}

	giacenzaBollettaNonLavorata() {
		const self = this;
		if (self.state.idsocio && self.state.magazzino_sorgente) {
			self.setState({
			}, function () {
				if (self.props.opt.endsWith("m2o")) {
					return IWAjax({
						app: self.$f7,
						route: 'getBollettaNonLavorata',
						data: {
							trasportatore: self.state.magazzino_sorgente._id,
							socio: self.state.idsocio._id
						},
						showPreloader: false,
						success: function (res) {
							console.log(res);
							if (res.data) {
								self.setState({bolletta_bins: res.data.bolletta_bins});
							} else {
								self.setState({bolletta_bins: "N/A"});
							}
						},
						error: function (error) {
							console.log(error);
							self.setState({bolletta_bins: "N/A"});
						}
					});
				}
			});
		}
	}


	getBolletteInOlma() {
		const $$ = Dom7;
		global.$$ = $$;
		const self = this;
		const app = self.$f7;
		global.app = app;

		if (Object.keys(self.state.magazzino_sorgente).length === 0)
			return;

		return IWAjax({
			app: self.$f7,
			route: 'getBollettaDaViaggio',
			data: {
				idmezzo: self.state.magazzino_sorgente._id
			},
			showPreloader: false,
			success: async function (res) {
				localStorage.setItem("is_bolletta_bin", "0");
				console.log("Bollette da camion RES: ");
				console.log(res);
				if (res.data.length > 0) {
					if (res.data.length === 1) {
						let smartSelect = app.smartSelect.get('.smart-select');
						smartSelect.setValue(res.data[0].idmezzo);

						let smartSelectTipo = app.smartSelect.get('.articoli_bins_ss .smart-select');
						smartSelectTipo.setValue(res.data[0].tipo_bin);
						self.setState({
							//numero_bins: res.data[0].bolletta_bins,
							tipo_bin: res.data[0].tipo_bin
						}, async () => {
							//$$('#articoli_bins option[value="' + res.data.tipo_bin + '"]').change();
						});
						const soci = await new Soci();
						soci.getById(res.data[0].idsocio).then(r => {
							self.setState({idsocio: r})
							$$('#idsocio input').val(r.full_desc);
						});
						self.setState({bolletta_bins: res.data[0].bolletta_bins});
						self.setState({bollette_da_viaggio: res.data});
						localStorage.setItem("is_bolletta_bin", "1");
					} else {
						// almeno 2 bollette
						self.setState({bollette_da_viaggio: res.data});
					}
				} else {
					if (localStorage.getItem("is_bolletta_bin") === "0") {
						app.methods.bollettaAssente();
						self.setState({bolletta_bins: 0, tipo_bin: 0, bollette_da_viaggio: [], idsocio: {}});
						$$('#idsocio input').val("");
					}
				}
			},
			error: function (error) {
				console.log(error);
				self.setState({bolletta_bins: 0, tipo_bin: 0});
			}
		});
	}


	async saveMovimentazione() {

		const trasp = await new Trasporti();
		const self = this;
		const app = self.$f7;

		if(self.props.opt === "c2s" || self.props.opt === "s2m" || self.props.opt === "m2o"){
			let coordinates = JSON.parse(app.methods.androidCoordinates());
			self.setState({latitudine: coordinates.lat});
			self.setState({longitudine: coordinates.lon});
			console.log(coordinates);
		}



		app.dialog.create({
			title: "Salvataggio Operazione",
			text: 'Effettuare il salvataggio?',
			cssClass: "iw-dialog",
			buttons: [
				{
					text: 'Annulla',
				},
				{
					text: 'Ok',
				}
			],
			onClick: async function (dialog, ind) {
				if (ind === 1) {

					const resp = await trasp.saveTrasportiFromView(self);

					if (self.props.opt==="o2s") self.setState({note_movimentazione:"MULETTO CONSEGNA BINS A SOCIO"})
					if (self.props.opt==="o2m") self.setState({note_movimentazione:"MULETTO CONSEGNA BINS A CAMION"})
					if (self.props.opt==="s2o") self.setState({note_movimentazione:"MULETTO RITIRO BINS DA SOCIO"})
					if (self.props.opt==="m2o" && !self.state.is_vuoti_camion) {
						let socio_cod = "";
						let socio_desc = "";
						if (self.state.idsocio !== undefined){
							socio_cod = self.state.idsocio.codice;
							socio_desc = self.state.idsocio.descrizione;
						}
						self.setState({note_movimentazione:"MULETTO RITIRO BINS DA CAMION DI [" + socio_cod + "] " + socio_desc})
					}
					if (self.props.opt==="m2o" && self.state.is_vuoti_camion) self.setState({note_movimentazione:"MULETTO RITIRO BINS VUOTI DA CAMION"})
					if (self.props.opt==="c2s") self.setState({note_movimentazione:"CAMION CONSEGNA BINS A SOCIO"})
					if (self.props.opt==="s2m") self.setState({note_movimentazione:"CAMION RITIRO BINS VUOTI DA SOCIO"})

					console.log("SALVATAGGIO MOV");
					console.log(self.state);

					if(parseInt(self.state.numero_bins) === 0){
						resp.ok = false;
						resp.message = "Inserire Numero Bins";
					}

					if(parseInt(self.state.tipo_bin) === 0){
						resp.ok = false;
						resp.message = "Selezionare tipo Bin";
					}

					if (self.props.opt === "m2o") {
						if (!self.state.is_vuoti_camion){
							if (localStorage.getItem("is_bolletta_bin") === "0" || parseInt(self.state.bolletta_bins) !== parseInt(self.state.numero_bins)){
								resp.ok = false;
								resp.message = "Bolletta Non Presente in OLMA";
							}
						}
						if (localStorage.getItem("is_bolletta_bin") === "1" && self.state.is_vuoti_camion){
							resp.ok = false;
							resp.message = "Bolletta Presente in OLMA: Rimuovere flag a VUOTI DA CAMION";
						}
						if (!self.state.idsocio && !self.state.is_vuoti_camion){
							resp.ok = false;
							resp.message = "Selezionare flag VUOTI DA CAMION se i BINS sono VUOTI";
						}
					}

					if (self.props.opt === "s2o"){
						if (self.state.barcode_pesate.length === 0 && !self.state.is_vuoti_socio){
							resp.ok = false;
							resp.message = "Selezionare flag VUOTI DA SOCIO se i BINS sono VUOTI oppure sparare il barcode della PESATA MULETTO";
						}
						if (self.state.barcode_pesate.length > 0 && self.state.is_vuoti_socio){
							resp.ok = false;
							resp.message = "Rimuovere flag VUOTI DA SOCIO";
						}
					}

					const success = resp.ok;
					app.methods.showIWResponse(resp);

					if (success) {
						app.methods.bgSync(2);
						if (self.props.opt === "o2o"){
							app.views.main.router.refreshPage();
						} else{
							self.$f7router.navigate("/home/");
						}
					}
				}
			}
		}).open();
	}

	async automezzoChanged() {
		const self = this;
		const app = self.$f7;
		let smartSelect = app.smartSelect.get('.smart-select');
		const idmezzo = smartSelect.getValue();
		console.log(idmezzo);
		if (self.props.opt === "m2o") {
			const magazzini = await new Mezzi();
			const sorgente = await magazzini.getById(self.state.idmezzo === 0 ? idmezzo : self.state.idmezzo);
			self.setState({magazzino_sorgente: sorgente});
			self.getBolletteInOlma();
			//self.giacenzaBollettaNonLavorata();
		}

		if (self.props.opt === "o2m") {
			const destinazione = await new Mezzi().getById(idmezzo);
			self.setState({magazzino_destinazione: destinazione});
		}
	}

	vuotiCheck(e) {
		const $$ = Dom7;
		global.$$ = $$;
		const self = this;
		self.setState({idsocio: undefined})
		$$('#idsocio input').val("");
		self.setState({is_vuoti_camion: e, is_vuoti_socio: e});
	}

	barcodeHandler(ret, ret1) {
		const self = this;
		if (!ret)
			ret = [];
		self.setState({bins: ret, tot_bins: ret.length, barcode_pesate: ret1});
		//if (self.props.opt === "m2o") {
		//	self.getBollettaDaViaggio(ret[0]);
		//}
	}

	numeroBinsHandler(ret){
		const self = this;
		if (!ret)
			ret = [];
		self.setState({numero_bins: ret});
	}

	tipoBinHandler(ret){
		const self = this;
		if (!ret)
			ret = [];
		self.setState({tipo_bin: ret});
	}

	updateBinsList() {
		const self = this;
		const cassoni = self.state.giacenza_bins;
		let bins = {};
		cassoni.forEach(function (riga) {
			bins[riga.id] = {
				"descrizione": riga.descrizione,
				"q": riga.q,
			}
		});
		self.setState({giacenza_tipo_bins: bins});
	}

	render() {
		const self = this;
		const {giacenza_tipo_bins} = self.state;
		const app = self.$f7;
		const $$ = Dom7;

		let title = "Consegna Bins A Socio";
		let dest;
		let dest_id = (self.props.opt.startsWith("o2") && self.props.opt !== "o2o")  ? "magazzino_destinazione" : "magazzino_sorgente";
		if (self.props.opt === "c2s") {
			dest_id = "magazzino_destinazione"
		}

		if (self.props.opt === "o2m") {
			title = "Consegna Bins A Camion";
			dest = <SelectAutomezzi
				id={'automezzi'}
				camion={self.state.magazzino_destinazione._id}
				onChange={self.automezzoChanged}
			/>
		} else {
			//let tsocio = self.state.magazzino_sorgente.is_bio !== undefined ? self.state.magazzino_sorgente.is_bio : self.state.magazzino_destinazione.is_bio;
			dest = <IWLocalAutocomplete
				title={"Socio"}
				id={dest_id}
				type={"Soci"}
				onChange={self.socioChanged}
				autofocus={false}
			/>
			if (self.props.opt.endsWith("2s")) {
				dest = <ListGroup>
					{dest}

					<ListItem title="Bins Già Consegnati" badge={self.state.qtot}
							  popupOpen="#giacenza_list-popup"
							  onChange={self.giacenzaBollettaNonLavorata()}
							  link={"#"}
							  className={(self.state.qtot + self.state.tot_bins) > self.state.max_bins ? "bg-color-red" : ""}/>
					<ListItem title="Bins Assegnabili" badge={self.state.max_bins.toString()}
							  className={(self.state.qtot + self.state.tot_bins) > self.state.max_bins ? "bg-color-red" : ""}/>
					<Popup id={"giacenza_list-popup"}>
						<Page>
							<Navbar
								title={"Giacenza Bins"}>
								<NavRight>
									<Link popupClose>Chiudi</Link>
								</NavRight>
							</Navbar>
							<List>
								{Object.keys(giacenza_tipo_bins).map((giacenza_tipo_bin, index) => (
									<ListItem title={giacenza_tipo_bins[giacenza_tipo_bin].codice}
											  badge={giacenza_tipo_bins[giacenza_tipo_bin].q}
											  key={index}>
									</ListItem>
								))}
							</List>
						</Page>
					</Popup>
				</ListGroup>

			}
		}
		if (self.props.opt === "s2o") {
			title = "Ritiro Bins Da Socio";
		}

		if (self.props.opt === "m2o") {
			title = "Ritiro Bins Da Camion";
			dest = <List className="no-margin no-padding">
				<SelectAutomezzi
					id={'automezzi-smartselect'}
					camion={self.state.magazzino_sorgente !== undefined ? self.state.magazzino_sorgente._id :  ""}
					onChange={self.automezzoChanged}
				/>
				<IWLocalAutocomplete
					title={self.state.idsocio !== undefined ? self.state.idsocio.is_bio !== "0" ? "Socio Bio" : "Socio": "Socio"}
					id="idsocio"
					type={"Soci"}
					onChange={self.socioChanged}
					autofocus={false}
				/>
				<ListItem
					key={"bollette_olma"}
					title={"Bollette in OL.MA."} badge={self.state.bollette_da_viaggio.length}
					smartSelect
					smartSelectParams={{
						cssClass: "testo_bollette",
						openIn: 'popup',
						closeOnSelect: 'true',
						on: {
							change: async function (e) {
								const bolletta = self.state.bollette_da_viaggio[e.getValue()];
								let smartSelectTipo = app.smartSelect.get('.articoli_bins_ss .smart-select');
								smartSelectTipo.setValue(self.state.bollette_da_viaggio[e.getValue()].tipo_bin);
								self.setState({bolletta_bins: bolletta.bolletta_bins, tipo_bin: bolletta.tipo_bin}, async () => {
									$$('#articoli_bins option[value="' + bolletta.tipo_bin + '"]').change();
								});
								const soci = await new Soci();
								soci.getById(bolletta.idsocio).then(r => {
									self.setState({idsocio: r})
									$$('#idsocio input').val(r.full_desc);
								});
								localStorage.setItem("is_bolletta_bin", "1");
							},
						}
					}}>
					<select name="bollette_olma" id="bollette_olma"> defaultValue={0}
					<option value="" selected disabled>Seleziona una Bolletta</option>
						{self.state.bollette_da_viaggio.map((bol, index) => (
							<option key={"bolviaggio_" + index} value={index}>{bol.descrizione_bolletta}</option>
						))}
				</select>
			</ListItem>

			<ListItem
				title="Bins in Bolletta"
					badge={self.state.bolletta_bins.toString()}
					className={(parseInt(self.state.numero_bins) === parseInt(self.state.bolletta_bins)) ? "bg-color-green" : "bg-color-red"}
				/>
				<ListItem>
					<span>Bins Vuoti da Camion</span>
					<Toggle
						name={"is_vuoti_camion"}
						onToggleChange={e => self.vuotiCheck(e)}
						disabled={localStorage.getItem("is_bolletta_bin") === "1"}
					/>
				</ListItem>
			</List>
		}

		if (self.props.opt === "s2o") {
			dest = <ListGroup>
				{dest}
				<ListItem>
				<span>Bins Vuoti da Socio</span>
					<Toggle
						name={"is_vuoti_socio"}
						onToggleChange={e => self.vuotiCheck(e)}
					/>
				</ListItem>
				<ListItem title="Numero Pesate" badge={self.state.barcode_pesate.length}
							 popupOpen="#barcode_pesate_list-popup"
							 link={"#"}/>
				</ListGroup>
		}

		if (self.props.opt === "s2m") {
			title = "Ritiro Bins Vuoti Da Socio";
		}

		return (
			<Page name="home">
				<IWHeader title={title}>
					<NavLeft backLink="Back"/>
					<NavRight>
						<Link onClick={self.saveMovimentazione.bind(self)}>Salva</Link>
					</NavRight>
				</IWHeader>
				<BlockTitle strong>{title}</BlockTitle>
				<List>
					{dest}
					<IWBarcodeReader
						barcodeHandler={self.barcodeHandler.bind(self)}
						magazzinoSorgente={self.state.magazzino_sorgente}
						magazzinoDestinazione={self.state.magazzino_destinazione}
					/>
					<IWBins
						numeroBinsHandler={self.numeroBinsHandler.bind(self)}
						tipoBinHandler={self.tipoBinHandler.bind(self)}
					/>
				</List>
			</Page>
		);
	}
}